/* eslint-disable react/forbid-prop-types */
/* eslint-disable react/state-in-constructor */
import React, { Component } from 'react';
import {
  func, object, oneOfType, arrayOf, node,
} from 'prop-types';
import { withRouter } from 'react-router-dom';
import { withAITracking } from '@microsoft/applicationinsights-react-js';

import { ai } from './telemetry-service';
import { APPINSIGHTS_INSTRUMENTATIONKEY } from '../env';

/**
 * This Component provides telemetry with Azure App Insights
 *
 * NOTE: the package '@microsoft/applicationinsights-react-js' has a HOC withAITracking
 * that requires this to be a Class Component rather than a Functional Component
 */
class TelemetryProvider extends Component {
  state = { initialized: false };

  componentDidMount() {
    const { history, after } = this.props;
    const { initialized } = this.state;
    const appInsightsInstrumentationKey = APPINSIGHTS_INSTRUMENTATIONKEY;
    if (!initialized && appInsightsInstrumentationKey && history) {
      ai.initialize(appInsightsInstrumentationKey, history);
      this.setState({ initialized: true });
    }

    after();
  }

  render() {
    const { children } = this.props;
    return (
      <>
        {children}
      </>
    );
  }
}

TelemetryProvider.propTypes = {
  history: object.isRequired,
  after: func,
  children: oneOfType([
    arrayOf(node),
    node,
  ]),
};

TelemetryProvider.defaultProps = {
  after: () => {},
  children: null,
};

export default withRouter(withAITracking(ai.reactPlugin, TelemetryProvider));
